import { Navigate, Route, Routes } from "react-router-dom";

import { NoAccess, SubNav } from "@/app/Shell";
import { CAP, useSession } from "@/auth/session";
import { RegistryShipPage } from "@/modules/registry/ShipPage";
import { RegistryTransferPage } from "@/modules/registry/TransferPage";
import { RegistryEnrollPage } from "@/modules/registry/EnrollPage";
import { RegistryOverviewPage } from "@/modules/registry/OverviewPage";
import { RegistryPairRepairPage } from "@/modules/registry/PairRepairPage";
import { RegistryInventoryPage } from "@/modules/registry/InventoryPage";

/** Registry module.
 *
 *  TWO TABS ARE PLATFORM-ONLY. Gate 1300 says you may open the registry; it
 *  never said which of the three write doors you may use.
 *
 *    Enroll     creates IDENTITIES — ENROL, internal-only in the matrix
 *    Transfer   changes OWNERSHIP, a sale — TRANSFER_OWNERSHIP, internal-only
 *
 *  Both were offered to every company_admin on Basic, and both are pages whose
 *  every button now returns 403. Overview, Inventory and Pair & repair stay: a
 *  customer runs their own fleet from them — ship, state, drivers, install.
 */
export function RegistryModule() {
  const { can } = useSession();
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav
          base="/registry"
          tabs={[
            { path: "overview", label: "Overview" },
            { path: "inventory", label: "Inventory" },
            { path: "enroll", label: "Enroll", gate: CAP.ENROL },
            { path: "transfer", label: "Transfer & ship", gate: CAP.TRANSFER_OWNERSHIP },
            // CUSTODY ONLY, and a separate door on purpose: ownership and
            // custody are independent axes (REGISTRY.md §10). Gated on SHIP,
            // not TRANSFER_OWNERSHIP — sending goods is not selling them, and
            // a repairer who may return your vehicle may not sell it.
            { path: "ship", label: "Ship & receive", gate: CAP.SHIP },
            { path: "pair-repair", label: "Pair & repair" },

          ]}
        />
      </div>
      <Routes>
        <Route path="overview" element={<RegistryOverviewPage />} />
        <Route path="inventory" element={<RegistryInventoryPage />} />
        <Route path="devices" element={<Navigate to="../inventory" replace />} />
        <Route path="enroll" element={
          can(CAP.ENROL) ? <RegistryEnrollPage /> : <NoAccess label="enrolment" />} />
        <Route path="transfer" element={
          can(CAP.TRANSFER_OWNERSHIP) ? <RegistryTransferPage />
                                      : <NoAccess label="ownership transfer" />} />
        {/* Keyed like every other sibling route: they render different
            components, so React cannot reuse an instance here — but a future
            fourth tab sharing a component would, which is the bug that put
            one subpage's contents under another's heading. */}
        <Route path="ship" element={
          can(CAP.SHIP) ? <RegistryShipPage /> : <NoAccess label="shipping" />} />
        <Route path="pair-repair" element={<RegistryPairRepairPage />} />
        <Route path="assets" element={<Navigate to="../inventory" replace />} />
        <Route path="parts" element={<Navigate to="../inventory" replace />} />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </>
  );
}

